<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <div class="d-flex align-items-center col-sm-6 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
				<div class="d-flex m-3 align-items-center w-100 ml-3">
					<span class="fs-small bold mr-2">Show inactive resources</span>
					<toggle-button @change="toggleShowInactive" v-model="showInactive" :labels="{checked: 'Yes', unchecked: 'No'}" />
				</div>
            </div>

            <button class="btn" @click="addResource">
                <i class="ico ico-add mt-1"></i> Add Resource
            </button>
        </div>

        <div v-if="getLoadingResources" class="p-4 text-center">
            <loader></loader>
        </div>

        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import List from '@/tools/list/baseList';
    import Search from '@/tools/Search';
    import Export from '@/tools/Export';
    import Loader from '@/tools/loaders/loader1';

    export default {
        data: function() {
            return {
                searchQuery:null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        availability: this.formatAvailability,
                        isActive: this.formatIsActive,
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
                rowEvent: null,
				showInactive: false
            }
        },
		created() {
			this.showInactive = this.showInactiveResources;
		},
		props: {
			showInactiveResources: {
				type: Boolean,
				required: false
			}
		},
        asyncComputed: {
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetResourceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        computed: {
            ...mapGetters([
                'getResources',
                'getResourcesLabels',
                'account',
                'getLoadingResources',
                'getShowInvoiceOption'
            ]),
            header: function() {
                const resourcesLabel = this.getResourcesLabels;
                const labels = {};

                labels.name = resourcesLabel.name;

                if (this.getShowInvoiceOption) {
                    labels.code = resourcesLabel.code;
                }

                labels.availability = resourcesLabel.availability;
                labels.isActive = resourcesLabel.isActive;

                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: labels,
                };
            },
            filteredResults: function() {
                if(this.searchQuery){
                    return this.getResources.filter(resource => {
                        return resource.name.toLowerCase().includes(this.searchQuery.toLowerCase());
                    });
                } else {
                    return this.getResources;
                }
            }
        },
        methods: {
            ...mapActions([
                'setSelectedItem',
                'initResources',
                'removeItem',
                'openModal',
                'setCreatingNewResource'
            ]),
			toggleShowInactive: function(){
				this.$emit('showInactiveResources', this.showInactive);
			},
            view: function (item) {
                this.setSelectedItem({ table: 'resources', id: item.id });
                this.setCreatingNewResource(false); // not creating new, is editing
                this.openModal('ResourceView');
            },
            addResource: function () {
                this.setCreatingNewResource(true); // creating new, not editing
                this.openModal('ResourceAdd');
            },
            remove: function(item) {
                this.removeItem({
                    table: 'resources',
                    object: 'resource',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Resource: item }
                });
            },
            formatName: function(resource) {
                return '<div class="bold">' + resource.name + '</div>';
            },
            formatAvailability: function(resource) {
                if (resource.availabilityType) {
                    return (resource.availability > 0) ? resource.availability + ' ' + resource.availabilityType : resource.availabilityType;
                }
                else {
                    return (resource.availability > 0) ? resource.availability : '-';
                }
            },
            formatIsActive: function(resource) {
                return resource.isActive ? 'Active' : '<div class="color-6">Inactive</div>';
            },
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// Resources.vue?7552fa64